interface Speaker {
  name: string;
  title: string;
  city: string;
  img: string;
}

const speakers: Speaker[] = [
  {
    name: 'Искра Д.А.',
    title: 'Профессор, научный руководитель конференции',
    city: 'Санкт-Петербург',
    img: '/img/speaker-iskra.png',
  },
  {
    name: 'Котова О.В.',
    title: 'Д.м.н., невролог, специалист по когнитивным нарушениям',
    city: 'Москва',
    img: '/img/speaker-kotova.jpg',
  },
  {
    name: 'Рачин А.П.',
    title: 'Профессор, чл.-корр. РАН, специалист по боли',
    city: 'Москва',
    img: '/img/speaker-rachin.jpg',
  },
  {
    name: 'Шперлинг Н.В.',
    title: 'Д.м.н., клинический фармаколог',
    city: 'Новосибирск',
    img: '/img/speaker-shperling.jpg',
  },
  {
    name: 'Воробьёва О.В.',
    title: 'Профессор, эпилептолог, невролог',
    city: 'Москва',
    img: '/img/speaker-vorobeva.jpg',
  },
  {
    name: 'Ситкали И.В.',
    title: 'К.м.н., специалист по ботулинотерапии',
    city: 'Санкт-Петербург',
    img: '/img/speaker-sitkali.jpg',
  },
  {
    name: 'Пизова Н.В.',
    title: 'Профессор, специалист по инсульту и реабилитации',
    city: 'Ярославль',
    img: '/img/speaker-pizova.jpg',
  },
  {
    name: 'Дутикова Е.Ф.',
    title: 'К.м.н., детский невролог, педиатр',
    city: 'Пермь',
    img: '/img/speaker-dutikova.jpg',
  },
];

export default function SpeakersSection() {
  const [moderator] = speakers;

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-5xl font-extrabold text-[#0f3d32] mb-4">
            Кто ведёт диалоги
          </h2>
          <p className="text-gray-500 text-lg">
            20+ спикеров из СПб, Москвы, Перми, Ставрополя, Владивостока.<br />
            Профессора, чл.-корр. РАН, заслуженные деятели науки.
          </p>
        </div>

        {/* Moderator */}
        <div className="border-2 border-[#c8963e]/40 rounded-2xl p-6 md:p-8 mb-10 flex flex-col sm:flex-row gap-6 items-center sm:items-start">
          <div className="w-24 h-24 flex items-center justify-center shrink-0">
            <img
              src={moderator.img}
              alt={moderator.name}
              className="w-24 h-24 rounded-full object-cover object-top"
            />
          </div>
          <div>
            <div className="inline-flex items-center gap-2 bg-[#c8963e]/10 rounded-full px-3 py-1 mb-3">
              <i className="ri-star-line text-[#c8963e] text-sm"></i>
              <span className="text-[#c8963e] text-xs font-semibold">Научный руководитель</span>
            </div>
            <h3 className="text-2xl font-extrabold text-[#0f3d32] mb-2">{moderator.name}</h3>
            <p className="text-gray-500 text-base">{moderator.title}</p>
            <p className="text-[#1a6b5a] text-sm font-medium mt-1">{moderator.city}</p>
          </div>
        </div>

        {/* PDF buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="/program16.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 bg-[#0f3d32] text-white font-semibold px-8 py-3 rounded-full hover:bg-[#1a6b5a] transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-file-list-line"></i>
            Программа 16.04
          </a>
          <a
            href="/program17.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 bg-[#0f3d32] text-white font-semibold px-8 py-3 rounded-full hover:bg-[#1a6b5a] transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-file-list-line"></i>
            Программа 17.04
          </a>
        </div>
      </div>
    </section>
  );
}
